<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: isRequired }">
  {{ label }}
</label>
<div class="control-wrapper">
  <div>
    <p-dropdown
      [options]="options"
      [placeholder]="'-' + (placeholder || defaultPlaceholder) + '-'"
      [ngModelOptions]="{ standalone: true }"
      (onChange)="selectValue($event)"
      [(ngModel)]="selectedValue"
      [disabled]="control.disabled || forceDisable"></p-dropdown>
    <app-errors [errors]="errors" [showErrors]="!control.pristine"></app-errors>
  </div>
</div>
